<button type="button" class="col-xs-6 col-md-6 need-help-chip center"
    (click)="clickToCall();openDrawer('clickToCallDrawer')" [disabled]="disabled">
    <img class="phone-icon mr-1" src="assets/icon/phone-icon.png">
    <span class="hide-mobile"> Need Help?</span>
</button>